"use client";
import React, { createContext, useContext, useState, useEffect } from "react";
import { BASE_URL } from "../config/apiConfig";
import { useAuth } from "./AuthContext";
// CHANGED: Removed unused `import { toast } from "react-toastify"` — this file only contains
// fetchDashboardData, a GET/fetch operation that never used toast notifications.

// Create Context
const DashboardContext = createContext();

// CHANGED: Added a safe JSON parsing helper to prevent "Unexpected token '<'" crashes.
// This guards against cases where the backend returns an HTML error page (404/500/proxy errors)
// or an empty body instead of valid JSON, which previously caused res.json() to throw.
const safeParseJSON = async (res) => {
  try {
    const text = await res.text();
    if (!text) {
      return { data: {} };
    }
    try {
      const parsed = JSON.parse(text);
      return { data: {}, ...parsed }; // ensure `data` is always at least an empty object
    } catch (parseErr) {
      return { data: {} };
    }
  } catch (readErr) {
    return { data: {} };
  }
};

// Provider
export const DashboardProvider = ({ children }) => {
  const [dashboardData, setDashboardData] = useState({
    totalEmployees: 0,
    totalClients: 0,
    totalProjects: 0,
    projects_status: [],
    project_summary: {
      pending_projects: 0,
      ongoing_projects: 0,
    },
    announcements : [],
  });
  const [loading, setLoading] = useState(true);
  const { isAuthenticated, token } = useAuth();
  

  // Fetch dashboard data — fetch operation, no toasts (none existed originally either)
  const fetchDashboardData = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${BASE_URL}/dashboard`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await safeParseJSON(res); // CHANGED: safe parsing instead of res.json()

      if (res.ok) {
        setDashboardData({
          totalEmployees: data.data.total_employees || 0,
          totalClients: data.data.total_clients || 0,
          totalProjects: data.data.total_projects || 0,
          projects_status: data.data.projects_list || [],
          project_summary: data.data.project_summary || { pending_projects: 0, ongoing_projects: 0 },
          announcements: data.data.announcements || [],
        });
      } else {
      
        setDashboardData((prev) => ({
          ...prev,
          projects_status: [],
          project_summary: { pending_projects: 0, ongoing_projects: 0 },
        }));
      }
    } catch (err) {
      setDashboardData((prev) => ({
        ...prev,
        projects_status: [],
        project_summary: { pending_projects: 0, ongoing_projects: 0 },
      }));
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchDashboardData();
  // }, []);
  useEffect(() => {
      if(!isAuthenticated) return;
      fetchDashboardData();
  }, [isAuthenticated, token]);

  return (
    <DashboardContext.Provider value={{ dashboardData, loading, fetchDashboardData }}>
      {children}
    </DashboardContext.Provider>
  );
};

// Hook for easier usage
export const useDashboard = () => useContext(DashboardContext);